<template>
  <div>
    <ak-type-input hideLabel v-model="data.model" :field="options" />
  </div>
</template>

<script>
import Bus from '../../assets/js/eventBus'
import store from '@/store'
export default {
  syncProps: ['value'],
  props: {
    value: null, // 当前这个字段的值，如果这个字段是虚构的，则必定是空
    field: Object // 当前field对象
  },
  data () {
    return {
      filters: {},
      data: {
        model: ''
      },
      options: {
        name: 'model',
        note: '所属车间型号',
        type: 'Pointer',
        targetClass: 'shopManagement',
        listWhere: (where) => {
          where.type = 'model'
          where.objectId = { $exists: true }
          if (store.state.user && store.state.user.allShopManagements === 'No') {
            where.parentNode = { $in: store.state.user.shopManagements }
          }
        }
      }
    }
  },
  mounted () {
    Bus.$on('reset', this.reset)
  },
  methods: {
    filterQuery () {
      if (this.data.model) {
        this._value = this.data.model
      } else {
        this._value = 'null'
      }

      return this._value
    },
    setValue () {
      this._value = this.data.model
    },
    async search (filters) { },
    reset (payload) {
      console.log('payload', payload)
      this.data.model = payload
    }
  },
  beforeDestroy () {
    Bus.$off('reset', this.reset)
  }
}
</script>

<style>

</style>
